<template lang="pug">
	.dropdown-asset-image(:class="{[theme]: true}")
		.dropdown-control(:class="{empty: !value, active: active}" v-pseudo-modal-show="this._uid + '-dropdown-asset-image'")
			.value(v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: value}") {{value || '&lt;empty&gt;'}}
			.drop-icon.fa.fa-caret-down
		.dropdown-menu(v-pseudo-modal="this._uid + '-dropdown-asset-image'" :style="{'max-height': `90vh`}" v-on:mouseover="active = true" v-on:mouseout="active = false")
			.dropdown-item(v-for="asset in assets" @click="setAsset(asset)")
				.fa.fa-image
				.asset-codename {{asset.codename}}
</template>

<script>
	import Screen from './../../../mixins/screen'

	import { Asset } from './../../../services/Asset'
	import { Version } from './../../../services/Version'

	export default {
		name: 'EditorPropertyImage',
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched"]
		},
		props: {
			value: {
				type: String,
				default: ''
			},
			theme: String
		},
		data() {

			this.assets = [];

			return {
				showed: true,
				active: false
			};

		},
		methods: {
			collectData() {

				this.assets = _.filter(Asset.getVersionAssets(Version.SelectedVersion), asset => asset.type === 'image');

			},
			setAsset(asset) {

				this.$emit('change', {assetCodename: asset.codename});

				Broadcast.call("Pseudo Modal Hide", [this._uid + '-dropdown-asset-image']);

			}
		}
	}
</script>

<style lang="sass">

	.dropdown-asset-image
		position: relative
		margin: 3px 0
		user-select: none
		border-radius: 0.1rem
		color: rgba(255, 255, 255, 0.87)
		background-color: rgba(255, 255, 255, 0.05)
		border: 1px solid rgba(255, 255, 255, 0.09)

		.dropdown-control
			border: 1px solid rgba(255, 255, 255, 0.00)
			border-radius: 0.25rem
			background: transparent no-repeat
			background-position-x: right 0.75rem
			background-position-y: calc(50% - 1px)
			background-size: 8px 10px
			padding-top: 0.15rem
			padding-bottom: 0.15rem
			padding-right: 2rem
			color: #fff
			cursor: pointer
			font-size: 0.765625rem
			white-space: nowrap

			.value
				width: 125px
				overflow: hidden
				text-overflow: ellipsis
				margin-left: 3px

			.drop-icon
				position: absolute
				right: 13px
				top: 8px
				color: rgba(255, 255, 255, 0.50)

		.dropdown-control:hover, .dropdown-control.active

			.value, .drop-icon
				color: #20a8d8

		.dropdown-menu
			top: 28px
			border-color: #3f454b
			width: 190px
			margin: 0
			padding: 0

			.dropdown-item
				display: flex
				flex-direction: row
				justify-content: flex-start
				padding: 0.25rem
				padding-left: 0.55rem
				font-size: 0.765625rem
				border-bottom: 1px solid rgba(0, 0, 0, 0.2)
				background-color: #555b5f

				&:last-child
					border-bottom: none

				&:hover
					background-color: rgba(255, 255, 255, 0.03)

				.fa
					display: flex
					align-items: center
					justify-content: center

				.asset-codename
					width: 160px
					overflow: hidden
					text-overflow: ellipsis
					margin-left: 7px

		.dropdown-control.empty
			background: rgba(255, 255, 255, 0.00) url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='rgba(255,255,255,0.3)' d='M2 5L0 3h4z'/%3e%3c/svg%3e") no-repeat
			background-position-x: right 0.75rem
			background-position-y: calc(50% - 1px)
			background-size: 8px 10px
			color: rgba(255, 255, 255, 0.30)

	.dropdown-asset-image.dark-medium
		display: flex
		margin: 0
		background: transparent
		border: 0

		.dropdown-control
			padding: 0

		.dropdown-control:hover, .dropdown-control.active

			.value, .drop-icon
				color: #fff

</style>
